<template>
  <div class="min-h-screen sm:ml-64 bg-gray-900 text-white flex flex-col">
    <SideBar />
    <div class="flex-1 flex items-center justify-center">
      <div class="grid grid-cols-2 md:grid-cols-3 gap-6">
        <!-- Productos -->
        <button
          @click="navigateTo('/productos')"
          class="flex flex-col items-center justify-center bg-gray-700 hover:bg-orange-500 transition-all duration-300 w-32 h-32 rounded-lg shadow-lg"
        >
          <i class="fas fa-box text-3xl mb-2"></i>
          <span class="text-sm">Productos</span>
        </button>

        <!-- Nueva venta -->
        <button
          @click="navigateTo('/venta')"
          class="flex flex-col items-center justify-center bg-gray-700 hover:bg-orange-500 transition-all duration-300 w-32 h-32 rounded-lg shadow-lg"
        >
          <i class="fas fa-shopping-cart text-3xl mb-2"></i>
          <span class="text-sm">Nueva Venta</span>
        </button>

        <!-- Historial Ventas -->
        <button
          @click="navigateTo('/ventas')"
          class="flex flex-col items-center justify-center bg-gray-700 hover:bg-orange-500 transition-all duration-300 w-32 h-32 rounded-lg shadow-lg"
        >
          <i class="fas fa-list text-3xl mb-2"></i>
          <span class="text-sm">Historial Ventas</span>
        </button>

        <!-- Generar presupuesto -->
        <button
          @click="navigateTo('/presupuesto')"
          class="flex flex-col items-center justify-center bg-gray-700 hover:bg-orange-500 transition-all duration-300 w-32 h-32 rounded-lg shadow-lg"
        >
          <i class="fas fa-file text-3xl mb-2"></i>
          <span class="text-sm">Generar Presupuesto</span>
        </button>

        <!-- Historial presupuestos -->
        <button
          @click="navigateTo('/presupuestos')"
          class="flex flex-col items-center justify-center bg-gray-700 hover:bg-orange-500 transition-all duration-300 w-32 h-32 rounded-lg shadow-lg"
        >
          <i class="fas fa-list text-3xl mb-2"></i>
          <span class="text-sm">Historial Presupuestos</span>
        </button>

        <!-- Clientes -->
        <button
          @click="navigateTo('/clientes')"
          class="flex flex-col items-center justify-center bg-gray-700 hover:bg-orange-500 transition-all duration-300 w-32 h-32 rounded-lg shadow-lg"
        >
          <i class="fas fa-user text-3xl mb-2"></i>
          <span class="text-sm">Clientes</span>
        </button>

        <!-- Reportes -->
        <button
          @click="navigateTo('/reportes')"
          class="flex flex-col items-center justify-center bg-gray-700 hover:bg-orange-500 transition-all duration-300 w-32 h-32 rounded-lg shadow-lg"
        >
          <i class="fas fa-pie-chart text-3xl mb-2"></i>
          <span class="text-sm">Balance</span>
        </button>

        <!-- Cerrar sesión (Solo si es necesario) -->
        <button
          href="#"
          @click.prevent="cerrarSesion"
          class="flex flex-col items-center justify-center bg-gray-700 hover:bg-orange-500 transition-all duration-300 w-32 h-32 rounded-lg shadow-lg"
        >
          <i class="fas fa-angle-double-left text-3xl mb-2"></i>
          <span class="text-sm">Cerrar sesión</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "../components/NavBar.vue";
import AuthStateHelper from "../helpers/authStateHelper";


export default {
  components: {
    SideBar, // Register the imported component here
  },
  methods: {
    navigateTo(route) {
      this.$router.push(route);
    },
    cerrarSesion() {
      AuthStateHelper.deleteAuth();
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped>
/* Iconos de Font Awesome (asegúrate de incluirlos en tu proyecto) */
@import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css");
</style>
